import { render, staticRenderFns } from "./HomeNotices.vue?vue&type=template&id=078fb711"
import script from "./HomeNotices.vue?vue&type=script&lang=js"
export * from "./HomeNotices.vue?vue&type=script&lang=js"
import style0 from "./HomeNotices.vue?vue&type=style&index=0&id=078fb711&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports